import AllActions from "@/infrastructure/rootAction";

import produce from "immer";
import { getType } from "typesafe-actions";

import * as A from "./actions";
import { defaultState } from "./defaults";

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(A.loadTemplate):
        draft.screener.setup = action.payload;
        break;

      case getType(A.fetchAnomalDataAsync.request):
        draft.loading.anomal = "REQUEST";
        break;
      case getType(A.fetchAnomalDataAsync.failure):
        draft.loading.anomal = "FAILURE";
        break;
      case getType(A.fetchAnomalDataAsync.success):
        draft.loading.anomal = "SUCCESS";
        draft.anomalyDate = action.payload.anomalyDate;
        draft.data = action.payload.data;
        break;

      case getType(A.fetchScreenerMetaAsync.request):
        draft.loading.meta = "REQUEST";
        break;
      case getType(A.fetchScreenerMetaAsync.failure):
        draft.loading.meta = "FAILURE";
        break;
      case getType(A.fetchScreenerMetaAsync.success):
        draft.loading.meta = "SUCCESS";
        draft.screener.meta = action.payload;
        break;

      case getType(A.fetchIndustryMetaAsync.request):
        draft.loading.industryMeta = "REQUEST";
        break;
      case getType(A.fetchIndustryMetaAsync.failure):
        draft.loading.industryMeta = "FAILURE";
        break;
      case getType(A.fetchIndustryMetaAsync.success):
        draft.loading.industryMeta = "SUCCESS";
        draft.screener.meta = {
          ...state.screener.meta,
          ...action.payload
        };
        break;

      case getType(A.fetchScreenerFilterAsync.request):
        draft.loading.filter = "REQUEST";
        break;
      case getType(A.fetchScreenerFilterAsync.failure):
        draft.loading.filter = "FAILURE";
        break;
      case getType(A.fetchScreenerFilterAsync.success):
        draft.loading.filter = "SUCCESS";
        draft.screener.result = action.payload;
        break;

      case getType(A.fetchNavBarDataAsync.request):
        draft.loading.navbar = "REQUEST";
        break;
      case getType(A.fetchNavBarDataAsync.failure):
        draft.loading.navbar = "FAILURE";
        break;
      case getType(A.fetchNavBarDataAsync.success):
        draft.loading.navbar = "SUCCESS";
        draft.screener.navbar[action.payload.type] = action.payload.data;
        break;

      case getType(A.updateScreenerSetup):
        draft.screener.setup = {
          ...state.screener.setup,
          ...action.payload
        };
        break;

      case getType(A.updateFundamentalSetup):
        const { index, data } = action.payload;

        draft.screener.setup.fundamental[index] = {
          ...draft.screener.setup.fundamental[index],
          ...data
        };
        break;
    }
  });
